/**
 * Parses priority fishtype IDs from resources data.
 * Supports multiple formats: array of numbers, comma-separated string, or single number.
 */
export const parsePriorityFishtypeIds = (rawValue: unknown): number[] => {
  if (Array.isArray(rawValue)) {
    return rawValue.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
  }

  if (typeof rawValue === 'string') {
    return rawValue
      .split(',')
      .map((id) => Number(id.trim()))
      .filter((id) => !Number.isNaN(id));
  }

  if (typeof rawValue === 'number') {
    return [rawValue];
  }

  return [];
};
